import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { RemarketingServiceGateway } from 'src/app/domain/models/remarketing/gateway/remarketing-service-gateway';
import { FunnelFlow } from 'src/app/domain/models/funnel/register-funnels/funnel-flow-register';
import { Brand } from 'src/app/domain/models/funnel/brand-enum';
import { AddressType } from 'src/app/domain/models/funnel/address-type-enum';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RemarketingService extends RemarketingServiceGateway {
  constructor(private http: HttpClient) {
    super();
  }

  public addPartialCustomer(funnelFlow: FunnelFlow, formStep: string): Observable<any> {
    const address = funnelFlow?.UserTemporary?.addresses?.find(a => a.addressType == AddressType.Primary);
    const partialCustomerRemarketingRequest = {
      email: funnelFlow?.UserTemporary?.email,
      firstName: funnelFlow?.UserTemporary?.firstName,
      lastName: funnelFlow?.UserTemporary?.lastName,
      phone: funnelFlow?.UserTemporary?.phone,
      affiliateId: funnelFlow?.EverflowAffiliate?.everflowAffiliateId,
      offerId: funnelFlow?.SubscriptionProduct?.funnel?.offerId,
      brand: Brand[funnelFlow?.Brand!],
      formStep: formStep,
      customerIP: funnelFlow?.SourceIPAddress,
      everflowSmartLinkId: funnelFlow?.UserEverflowEvent?.EverflowSmartLinkId,
      everflowSub1: funnelFlow?.UserEverflowEvent?.EverflowSub1,
      everflowSub2: funnelFlow?.UserEverflowEvent?.EverflowSub2,
      streetAddress: address?.streetAddress,
      city: address?.city,
      state: address?.state,
      zip: address?.zip,
    }
    return this.http.post<any>(`${environment.apiUrl}/api/remarketing/add`, partialCustomerRemarketingRequest).pipe(map((response: any) => {
      return response
    }));
  }
}
